import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsEditRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-edit',
	path: '(/secure/|/)project/EditProject([!%]?[\\w]*).jspa',
	query: ['pid'],
};
